import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import { deleteWelder, getAllWelder, getAllWpqByWelder, UpdateWelder } from "../../Services/Welder-services";
import AddEditWelderMaster from "./AddEditWelderMaster";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";

import GridMaster from "../utility/grid/GridMaster";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import Toaster, { showSuccess as showSuccessToast, showWarning } from "../utility/ui/notifications/Toaster";
import Export_blue from "../../icons/Export_blue.svg";
import ExportIcon from "../../icons/ExportIcon.svg";

const Welder = forwardRef((props, ref) => {
  let formName = "Welder";
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setcolumnDefs] = useState([]);
  const [Welder, setWelder] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [data, setdata] = useState("");
  const [reload, setReload] = useState(false);
  const [excelData1, setExcelData] = useState([]);
  const childRef = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const msg = "";
  const history = useNavigate();
  const [show1, setShow1] = useState(false);
  const tmpcolumnDefs = [
    {
      headerName: "Status",
      field: "wld_status",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "statusRenderer",
      sortable: true,
      sort: 'asc',
    },
    {
      headerName: "Welder Code",
      field: "wld_code",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Salary Code",
      field: "wld_salarycode",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Name",
      field: "wld_name",
      type: "Text",
      isCheckbox: false,
      minWidth: 300,
      cellRenderer: "AvatarCellRenderer",
    },
    {
      headerName: "Company Name",
      field: "wld_companyname",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Plant",
      field: "wld_plant",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "DOB",
      field: "wld_dob",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Address",
      field: "wld_address",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Language",
      field: "wld_language",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Mobile",
      field: "wld_mobile",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Fax",
      field: "wld_fax",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Telephone",
      field: "wld_telephone",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Email",
      field: "wld_email",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
  ];

  const handleEdit = (row) => {
    setAction("Edit");
    setRowData(row);
    setShowForm(true);
  };

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchWelder = async () => {
    const result = await getAllWelder();
    setWelder(result);
    setFilteredResult(result);
  };

  const fetchColumnDefns = async () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result.push({
      field: "", cellRenderer: actionRenderer, width: 250, suppressMenu: true,
      sortable: false,
    });
    setcolumnDefs(result);
  };

  useEffect(() => {
    fetchWelder();
    fetchColumnDefns();
  }, [reload]);

  useImperativeHandle(ref, () => ({
    handleAdd: async () => {
      setAction("Add");
      setShowForm(true);
      setReload(true);
    },
  }));

  const resetForm = () => {
    document.filterForm.reset();
    setFilteredResult(Welder);
  };

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setWelder",
    });
  };

  const handleCloseSuccess = () => setShowSuccess(false);

  const handleClose = () => {
    setShow1(false);
  };

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text);

  };

  const handleGlobalExport = () => {
    let filename = "WelderMaster";
    setExcelData(filteredResult);
    handleExport1(excelData1, filename, tmpcolumnDefs);
  };

  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={['edit', 'delete']}
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };

  const handleDelete = async (row) => {
    let result;
    let reqData = {};
    if (data.wld_salarycode) {
      reqData = {
        salaryId: data.wld_salarycode
      }
    } else {
      reqData = {
        welderId: data.wld_code
      }
    }
    //This is to validate if wpq record is not created for the welder
    let res = await getAllWpqByWelder(reqData)
    const { canDelete } = res;
    if (canDelete) {
      setShow1(false);
      result = await deleteWelder(reqData);
      showSuccessToast(`Selected Welder has been deleted successfully`);
      await fetchWelder();
      return;
    } else {
      data.wld_status = "Inactive";
      data.wld_code = String(data.wld_code);
      try {
        result = await UpdateWelder(data);
        if (result && result.message === "Success") {
          setShowForm(false);
          showSuccessToast(`WPQ record exists, Selected Welder has been deactivated successfully`);
        } else {
          showWarning("Error!!!, Not able to deactivate Welder");
        }
      } catch (error) {
        showWarning("Error!, Not able to deactivate Welder");
      } finally {
        setReload(!reload);
        setdata("");
        setShow1(false);
      }
    }

  };

  return (
    <Container fluid>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={msg}
        show={showSuccess}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleDelete}
        formName={formName}
        show={show1}
        handleClose={handleClose}
      />

      <Row className="RowHeight">
        <Col md={2} sm={12} xs={12} className="ListTitle">
          Welder list
        </Col>
        <Col>
          <div className="global-search-container">
            <GolbalSearch
              filterFunc={handleGlobalSearch}
              searchplaceholdertext={
                "Search for Welder Code, Salary Code, Name, Email..."
              }
            />
            {/* <img
              className="allexport"
              src={Export}
              alt="Export"
              onClick={handleGlobalExport}
            /> */}
            <img
              className="allexport"
              src={ExportIcon}
              onMouseOver={(e) => (e.currentTarget.src = Export_blue)}
              onMouseOut={(e) => (e.currentTarget.src = ExportIcon)}
              alt="ExportIcon"
              onClick={handleGlobalExport}
            />
          </div>
        </Col>
      </Row>
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}
        setExcelData={setExcelData}
        paginationPageSize={7}
        ref={childRef}
      />
      {showForm && (
        <AddEditWelderMaster
          show={showForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowForm(false)}
          resetForm={resetForm}
          setReload={setReload}
          reload={reload}
          fetchUserMaster={fetchWelder}
          allRecs={Welder}
          backdrop="static"
        />
      )}

      <Toaster />
    </Container>
  );
});

export default Welder;
